import * as React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'

interface ContractPaymentConfirmationWidgetProps {
  task: any
  isCanceled: boolean
}

export default function ContractPaymentConfirmationWidget({
  task,
  isCanceled
}: ContractPaymentConfirmationWidgetProps) {
  const [files, setFiles] = React.useState<any[]>([])
  const [isContractReturnedByClient, setIsContractReturnedByClient] =
    React.useState(task.meta?.isContractReturnedByClient || false)

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      isCanceled={isCanceled}
      label="Юридический отдел"
      onSave={() =>
        sendParameters(
          task.paidServiceId,
          task.id,
          { isContractReturnedByClient },
          files
        )
      }
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Typography variant="subtitle1" color="black">
          Подписанный договор с контрагентом (скан)
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              disabled={!enabled}
              checked={isContractReturnedByClient}
              onChange={(e) => setIsContractReturnedByClient(e.target.checked)}
            />
          }
          label="Договор возвращён контрагентом"
        />
        {enabled ? (
          <FileUpload
            files={files}
            onUpload={(file: any) => setFiles([...files, file])}
            onDelete={(id: number) =>
              setFiles(files.filter((file: any) => file.id !== id))
            }
          />
        ) : (
          <FileViewWidget files={task.files} />
        )}
      </Box>
    </TaskWrapper>
  )
}
